(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const initialize = () => document.querySelectorAll('[data-blano-inquiry-root]').forEach((root) => {
    if (root.dataset.gmlMobileInquiryReady) return;
    root.dataset.gmlMobileInquiryReady = 'true';
    const modal = root.querySelector('[data-blano-inquiry-modal]');
    const form = root.querySelector('form');
    if (!modal || !form) return;
    let reference = form.querySelector('[name="contact[Reference]"]');
    const originalReference = reference?.value;
    let createdReference = false;
    let productLink = null;
    const update = () => {
      if (!mobile.matches) {
        modal.style.removeProperty('--gml-inquiry-viewport-height');
        modal.style.removeProperty('--gml-inquiry-viewport-top');
        if (createdReference) { reference?.remove(); reference = null; createdReference = false; }
        else if (reference) reference.value = originalReference;
        productLink?.remove();
        productLink = null;
        return;
      }
      const viewport = window.visualViewport;
      modal.style.setProperty('--gml-inquiry-viewport-height', `${viewport?.height || window.innerHeight}px`);
      modal.style.setProperty('--gml-inquiry-viewport-top', `${viewport?.offsetTop || 0}px`);
      if (root.dataset.gmlMobileReference) {
        if (!reference) {
          reference = document.createElement('input');
          reference.type = 'hidden';
          reference.name = 'contact[Reference]';
          form.append(reference);
          createdReference = true;
        }
        reference.value = root.dataset.gmlMobileReference;
      }
      // Keep a direct product URL beside the existing phone contact-action link.
      if (root.dataset.gmlMobileProductUrl) {
        if (!productLink) {
          productLink = document.createElement('input');
          productLink.type = 'hidden';
          productLink.name = 'contact[Product link]';
          form.append(productLink);
        }
        productLink.value = root.dataset.gmlMobileProductUrl;
      }
    };
    update();
    mobile.addEventListener('change', update);
    window.addEventListener('resize', update, { passive: true });
    window.visualViewport?.addEventListener('resize', update, { passive: true });
    window.visualViewport?.addEventListener('scroll', update, { passive: true });
    new MutationObserver(update).observe(root, { attributes: true, attributeFilter: ['class'] });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
